import React from 'react';
import Modal from 'react-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';

interface ModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSuccess?: any;
}

const OrderStaffModal: React.FC<ModalProps> = ({ isOpen, onCancel, onSuccess }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className="bottom-modal"
      closeTimeoutMS={100}
      ariaHideApp={false}
      style={{
        overlay: {
          height: '100vh',
          display: 'flex',
          alignItems: 'flex-end',
          bottom: '0',
        },
      }}>
      <Style>
        <div className="alertModalWrap">
          <div className="modalContentWrap">
            <img
              onClick={onCancel}
              className="closeIcon"
              src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
              alt="닫기 아이콘"
            />
            <img src={`${process.env.PUBLIC_URL}/svg/status_success2.svg`} alt="취소 아이콘" />
            <h2>직원 확인</h2>
            <p>
              이 버튼은 직원 전용입니다
              <br />
              신중하게 선택해 주세요
            </p>
            <button onClick={onSuccess}>사용 완료</button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default OrderStaffModal;
const Style = styled.div`
  h2 {
    margin: 10px 0 24px 0;
    font-size: 20px;
    font-weight: 600;
    color: #555;
  }
  p {
    font-size: 1rem;
    font-weight: 500;
    color: #999;
    line-height: 25px;
  }

  .modalContentWrap {
    width: 100vw;
    height: 55vh;
    position: relative;
    padding: 40px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #fff;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    padding-bottom: 100px;

    button {
      width: 100%;
      margin-top: 36px;
      padding: 11px 0;
      background: #ff6060;
      color: #fff;
      font-size: 20px;
      font-weight: 600;
      border-radius: 10px;
    }
    .closeIcon {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
`;
